import instance from "@/services/api";

export const avrSettingAPI = {
  async getList() {
    return await instance()
      .get("/handbook/inagro_konstruktivs/avr_setting/read/")
      .then((res) => res?.data);
  },
  async update(body) {
    return await instance()
      .put("/handbook/inagro_konstruktivs/avr_setting/upd/", body)
      .then((res) => res?.data);
  },
};
